import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getProjectRowFromMap } from './tvcIssuesSectionHelpers';

/**
 * Local UI state for project picker, check rail, list accordion, and optimistic remove animation.
 */
const useTvcIssuesUiState = _ref => {
  var _selectedProjectRow$t;
  let projectsContent = _ref.projectsContent,
    active = _ref.active,
    change = _ref.change,
    changeQuietly = _ref.changeQuietly,
    path = _ref.path;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedProjectUuid = _useState2[0],
    setSelectedProjectUuid = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    expandedAssetTypes = _useState4[0],
    setExpandedAssetTypes = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCheck = _useState6[0],
    setSelectedCheck = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    expandedStableRowKey = _useState8[0],
    setExpandedStableRowKey = _useState8[1];
  const _useState9 = useState(() => new Set()),
    _useState0 = _slicedToArray(_useState9, 2),
    removedIssueKeys = _useState0[0],
    setRemovedIssueKeys = _useState0[1];
  const _useState1 = useState(() => new Set()),
    _useState10 = _slicedToArray(_useState1, 2),
    animatingOutKeys = _useState10[0],
    setAnimatingOutKeys = _useState10[1];
  const selectedProjectRow = useMemo(() => getProjectRowFromMap(projectsContent, selectedProjectUuid), [projectsContent, selectedProjectUuid]);
  const selectedProjectTitle = selectedProjectRow ? String((_selectedProjectRow$t = selectedProjectRow.title) !== null && _selectedProjectRow$t !== void 0 ? _selectedProjectRow$t : '').trim() : '';
  useEffect(() => {
    if (selectedCheck && selectedCheck.projectName !== selectedProjectTitle) {
      setSelectedCheck(null);
    }
  }, [selectedProjectTitle, selectedCheck]);
  useEffect(() => {
    setExpandedStableRowKey(null);
  }, [selectedCheck]);
  const handleListRowToggle = useCallback(stableKey => {
    setExpandedStableRowKey(prev => prev === stableKey ? null : stableKey);
  }, []);
  const handleRestoreSucceeded = useCallback(stableKey => {
    setAnimatingOutKeys(prev => new Set([...prev, stableKey]));
    setExpandedStableRowKey(prev => prev === stableKey ? null : prev);
  }, []);
  const handleRowExitAnimationEnd = useCallback(stableKey => {
    setAnimatingOutKeys(prev => {
      const next = new Set(prev);
      next.delete(stableKey);
      return next;
    });
    setRemovedIssueKeys(prev => new Set([...prev, stableKey]));
  }, []);
  const handleProjectChange = useCallback(e => {
    const uuid = e.target.value || '';
    setSelectedProjectUuid(uuid);
    setSelectedCheck(null);
    if (!uuid && active !== null && active !== void 0 && active.id) {
      const writePath = "content".concat(path);
      if (changeQuietly) {
        changeQuietly(active.id, writePath, {});
      } else if (change) {
        change(active.id, writePath, {});
      }
    }
  }, [active === null || active === void 0 ? void 0 : active.id, change, changeQuietly, path]);
  const toggleAssetType = useCallback(assetName => {
    setExpandedAssetTypes(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [assetName]: !prev[assetName]
    }));
  }, []);
  const selectCheck = useCallback((projectName, assetType, errorType) => {
    setSelectedCheck({
      projectName,
      assetType,
      errorType
    });
  }, []);
  const isCheckSelected = useCallback((projectName, assetType, errorType) => selectedCheck && selectedCheck.projectName === projectName && selectedCheck.assetType === assetType && selectedCheck.errorType === errorType, [selectedCheck]);
  return {
    selectedProjectUuid,
    selectedProjectTitle,
    expandedAssetTypes,
    selectedCheck,
    expandedStableRowKey,
    removedIssueKeys,
    animatingOutKeys,
    handleListRowToggle,
    handleRestoreSucceeded,
    handleRowExitAnimationEnd,
    handleProjectChange,
    toggleAssetType,
    selectCheck,
    isCheckSelected
  };
};
export default useTvcIssuesUiState;